import { useCallback, useState } from 'react';

const STORAGE_KEY = 'aipa_consent_choices';

export type ConsentChoices = Record<string, boolean>;

function readStoredChoices(): ConsentChoices {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? (JSON.parse(raw) as ConsentChoices) : {};
    } catch {
        return {};
    }
}

/** Per-viewer cookie-category choices, persisted client-side only — there's no visitor identity to attach a server-side record to before login. */
export function useConsentChoices() {
    const [choices, setChoices] = useState<ConsentChoices>(readStoredChoices);

    const save = useCallback((next: ConsentChoices) => {
        setChoices(next);
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        } catch {
            // Best-effort only — private browsing / blocked storage shouldn't break the popup.
        }
    }, []);

    return { choices, save };
}
